"use client"
import { LoadingOutlined } from "@ant-design/icons"
import { ComponentConfig } from "@measured/puck"
import { message, Spin } from "antd"
import { useEffect, useState } from "react"
import { fetchDepartment } from "../../../../../recruitment/services/recruitment"
import { DepartmentData } from "../../../types"

export const RenderDepartmentRecruitment: ComponentConfig = {
  render: () => {
    const [loading, setLoading] = useState<boolean>(false)
    const [departments, setDepartments] = useState<DepartmentData[]>([])

    const fetchDepartments = async () => {
      setLoading(true)
      try {
        const departmentResponse = await fetchDepartment()
        setDepartments(departmentResponse.data || [])
      } catch (error) {
        message.error("Failed to fetch department data")
      } finally {
        setLoading(false)
      }
    }

    useEffect(() => {
      fetchDepartments()
    }, [])

    if (loading)
      return (
        <Spin
          indicator={
            <LoadingOutlined
              style={{
                fontSize: 60,
              }}
              spin
            />
          }
        />
      )

    return (
      <>
        <div className="flex flex-col gap-3 sm:flex-row sm:gap-6">
          {departments.map(department => (
            <p key={department.attributes.Name} className="text-[24px] font-medium">
              <a href={`/tim-kiem?search=${department.attributes.Name}`}>{department.attributes.Name}</a>
            </p>
          ))}
        </div>
      </>
    )
  },
}
